import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Users, ArrowLeft, Mail, Phone, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import ApplyForm from './ApplyForm';
import { companyInfo } from '../data/mock';

const ApplyPage = () => {
  return (
    <section className="form-section py-16 lg:py-24 min-h-screen">
      <Helmet>
        <title>Caregiver Jobs in Columbus, Ohio | Apply Now - A Gentle Touch HomeCare</title>
        <meta name="description" content="Join our team at A Gentle Touch HomeCare. We're hiring compassionate caregivers for non medical home care positions in Columbus, Ohio. Apply online or call 614-928-4169." />
        <link rel="canonical" href="https://agentletouchhomecare.com/apply" />
      </Helmet>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Back to Home Link */}
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-[#008080] hover:text-[#006666] mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>

        {/* Apply Form Card */}
        <div className="form-card">
          <div className="flex items-center gap-3 mb-6">
            <div
              className="w-12 h-12 rounded-xl flex items-center justify-center"
              style={{ background: 'rgba(196, 165, 126, 0.2)' }}
            >
              <Users className="w-6 h-6" style={{ color: '#c4a57e' }} />
            </div>
            <div>
              <h1
                className="text-2xl sm:text-3xl font-display font-semibold"
                style={{ color: '#c49bc4' }}
              >
                Join Our Team
              </h1>
              <p className="text-gray-500 text-sm">Apply to work with us</p>
            </div>
          </div>

          {/* Intro + Contact Info */}
          <div
            className="mb-6 p-4 rounded-xl space-y-3"
            style={{ background: 'rgba(196, 165, 126, 0.1)' }}
          >
            <p className="text-gray-600">
              We&apos;re always looking for compassionate caregivers to join our team.
              If you have a passion for helping others, we&apos;d love to hear from you.
            </p>

    


            {/* Hours */}
            <div className="flex items-start gap-2 text-sm text-gray-600">
              <Clock className="w-4 h-4 mt-0.5" />
              <div>
                <p>Monday – Thursday: 8:00 AM – 4:00 PM</p>
                <p>Friday: 8:00 AM – 3:00 PM</p>
              </div>
            </div>
          </div>

          {/* Apply Form */}
          <ApplyForm />
        </div>
      </div>
    </section>
  );
};

export default ApplyPage;
